"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _Uri = _interopRequireDefault(require("../../Uri"));

var _replaceParameters = _interopRequireDefault(require("../replaceParameters"));

var _constructor = _interopRequireDefault(require("../../../constants/constructor"));

var _clone = _interopRequireDefault(require("../../utils/clone"));

/* istanbul ignore file */
// libraries
// constants
class RouteWithParametersDecorator {
  [_constructor.default]() {
    this.parameters = {};
  }
  /**
   * @param {string} parameterName
   * @param {string} parameter
   */


  setParameter(parameterName, parameter) {
    this.parameters[parameterName] = parameter;
  }
  /**
   * @param {object} parameters
   */


  setParameters(parameters) {
    this.parameters = parameters;
  }

  getParameter(parameterName) {
    return this.parameters[parameterName];
  }
  /**
   * @return {object}
   */


  getParameters() {
    return this.parameters;
  }

  getMatchUri() {
    const uri = (0, _clone.default)(this.uri, new _Uri.default());
    const parameters = this.getParameters();
    let path = this.uri.getPath();

    if (path) {
      path = (0, _replaceParameters.default)(path, parameters);

      if (!/^\/+$/.test(path)) {
        path = path.replace(/\/+$/, "");
      }

      path = path.replace(/(?:\/){2,}/, "/");
    }

    let query = this.uri.getQuery();

    if (query) {
      query = (0, _replaceParameters.default)(this.uri.getQuery(), parameters);
      query = query.replace(/\?/, "");
    }

    uri.setPath(path);
    uri.setQuery(query);
    return uri;
  }

}

exports.default = RouteWithParametersDecorator;